export default __webpack_public_path__ + "static/media/preview-moment.5a74e440.png";